import Inputmask from "inputmask";
import $ from "jquery";
import datepicker from "eonasdan-bootstrap-datetimepicker"; // eslint-disable-line

export default {
  data: null,
  hook: function () {
    this.maskPostal();
  },
  maskIdNumber: function () {
    Inputmask({
      mask: "aaa 999999",
    }).mask(".idNumber");
  },
  maskPassportNumber: function () {
    // Inputmask({
    //   mask: ["aa9999999", "aa999999"],
    // }).mask(".passportNumber");
  },
  datepicker() {
    Inputmask({
      mask: "9999-99-99",
      oncomplete: function (e) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("input", true, true);
        e.currentTarget.dispatchEvent(event);
        $(this).trigger("change");
      },
    }).mask(".datepicker");

    $(".datepicker")
      .datetimepicker({
        locale: "pl",
        format: "YYYY-MM-DD",
      })
      .on("change", function () {
        // $(this).valid()
      })
      .unbind("change")
      .unbind("dp.change")
      .on("dp.change", function (e) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("input", true, true);
        e.currentTarget.dispatchEvent(event);
        $(this).trigger("change");
        // $(this).valid()
      });
  },
  maskPostal: function () {
    Inputmask({
      mask: "99 9999 9999 9999 9999 9999 9999",
      oncomplete: function (e) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("input", true, true);
        e.currentTarget.dispatchEvent(event);
        $(this).trigger("change");
      },
    }).mask(".bank_account");
    Inputmask({
      mask: "99-999",
      oncomplete: function (e) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("input", true, true);
        e.currentTarget.dispatchEvent(event);
        $(this).trigger("change");
      },
    }).mask(".postal");
    Inputmask({
      mask: "99999999999",
      oncomplete: function (e) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("input", true, true);
        e.currentTarget.dispatchEvent(event);
        $(this).trigger("change");
      },
    }).mask(".pesel");
  },
};
